module.exports = "/images/minimarket.svg?45d3b22a25f2c786d57f1cb5c6c288da";